import type { Destinations } from "@/queries/getDestinations";
import { listThemes, listVoyagesCulturels } from "../SMGideas";
import { Container } from "../mobileMenu/Container";
import type { Data } from "../mobileMenu/MobileMenuInner";
import { mobileColumns } from "../mobileMenu/mobileColumns";

type Props = {
  destinations: Destinations;
};
export const SMGMobileMenu = ({ destinations }: Props) => {
  let allData: Data = {
    root: {
      id: "root",
      children: [
        {
          title: "Destinations",
          to: "destinations",
        },
        {
          title: "Thématiques",
          to: "ideas",
        },
      ],
    },
    destinations: {
      id: "destinations",
      title: "Destinations",
      back: "root",
      children: [],
      isDestination: true,
    },
    ideas: {
      id: "ideas",
      title: "Thèmes",
      back: "root",
      children: [
        {
          title: "Voyages culturels",
          to: "voyages-culturels",
        },
        {
          title: "Thèmes",
          to: "themes",
        },
      ],
    },
    themes: {
      id: "themes",
      title: "Thèmes",
      back: "ideas",
      children: listThemes,
    },
    "voyages-culturels": {
      id: "voyages-culturels",
      title: "Voyages culturels",
      back: "ideas",
      children: listVoyagesCulturels,
    },
  };

  const regions = destinations.map((destination) => ({
    id: destination.id,
    title: destination.title,
    alias: destination.alias,
    places: destination.countries
      .map((child) => ({
        id: child.id,
        title: child.title,
        alias: child.alias,
        departures: child.count,
      }))
      .filter((d) => d.departures !== 0),
  }));

  const dest: Array<{
    title: string;
    to?: string;
    href?: string;
  }> = [];

  for (const element of mobileColumns) {
    const dests = regions
      .filter((d) => element.alias.includes(d.alias))
      .flatMap((d) => d.places)
      .sort((a, b) => a.title.localeCompare(b.title));

    if (dests.length === 0) continue;

    dest.push({
      title: element.title,
      to: element.title,
    });

    allData = {
      ...allData,
      [element.title]: {
        id: element.title,
        title: element.title,
        back: "destinations",
        children: dests.map((place) => ({
          title: place.title,
          href: `/voyages-culturels/${place.alias}/`,
        })),
      },
    };
  }

  allData.destinations.children = dest;

  return <Container data={allData} menuThemeCards={null} hideActivities />;
};
